<template>
    <div>
        <el-row>
            <h2>订单管理</h2>
        </el-row>
        <el-row>
            <el-col>
                <el-form :inline="true" class="demo-form-inline" style="padding-top:0;margin-top:0" :model="searchForm"
                         ref="searchForm">
                    <el-form-item label="供应商：">
                        <el-input v-model="searchForm.SUPPLIER"></el-input>
                    </el-form-item>
                    <el-form-item label="产品编码：">
                        <el-input v-model="searchForm.PRODUCT"></el-input>
                    </el-form-item>
                    <el-form-item label="日期范围：">
                        <el-date-picker
                                v-model="value7"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions2" value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="search">筛选</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="2">
                <el-button @click="editPrice" style="margin-bottom: 20px">调整价格</el-button>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-table :data="orderData" border stripe style="width: 100%">
                    <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
                    <el-table-column prop="INNER_CODE" label="产品编码" width="150"></el-table-column>
                    <el-table-column prop="PRODUCT_NAME" label="产品名称" width="150"></el-table-column>
                    <el-table-column prop="SEND_DAY" label="送货日期" width="150"></el-table-column>
                    <el-table-column prop="PROJECT_PRICE" label="项目点价格" min-width="150"></el-table-column>
                    <el-table-column prop="REAL_PRICE" label="供应商价格"></el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <el-dialog title="新增产品" center :visible.sync="addFormVisible" width="600px" @close="resetContent('addForm')" :close-on-click-modal="false">
            <el-form :model="addForm" ref="addForm" >
                <el-form-item label="采购价：" :label-width="formLabelWidth">
                    <el-input v-model="addForm.realPrice"></el-input>
                </el-form-item>
                <el-form-item label="销售价：" :label-width="formLabelWidth">
                    <el-input v-model="addForm.soldPrice"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetContent()">取 消</el-button>
                <el-button @click="submitAdd()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import http from '@/api/base/http';
// eslint-disable-next-line no-unused-vars
import date from '@/common/date';

export default {
  data() {
    return {
      searchForm: {},
      orderData: [],
      addForm: {},
      addFormVisible: false,
      formLabelWidth: '100px',
      pickerOptions2: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          },
        }],
      },
      value7: '',
    };
  },
  methods: {
    submitAdd() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '11000',
            OTYPE: 8,
            SUPPLIER_PRICE: this.addForm.realPrice,
            PROJECT_PRICE: this.addForm.soldPrice,
            SUPPLIER_ID: this.searchForm.SUPPLIER,
            PRODUCT_CODE: this.searchForm.PRODUCT,
            START_DAY: this.value7[0],
            END_DAY: this.value7[1],
          };
          http.post(params).then((result) => {
            this.$message.show({ text: '成功', type: 'success' });
            this.addFormVisible = false;
            this.search();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    resetContent() {
      this.addFormVisible = false;
      this.addForm = {};
    },
    search() {
      const params = {
        SERVICE_ID: '11000',
        OTYPE: 7,
        SUPPLIER_ID: this.searchForm.SUPPLIER,
        PRODUCT_CODE: this.searchForm.PRODUCT,
        START_DAY: this.value7[0],
        END_DAY: this.value7[1],
      };
      http.post(params).then((result) => {
        this.orderData = result;
        console.log(result);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    editPrice() {
      this.addFormVisible = true;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/checkPrice.vue